// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/abs/views/account/Register/Domestic/Phone/PrivacyAgreement/index.less
// module id = 829
// module chunks = 42